import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { EntitlementsService } from './../entitlements/entitlements.service';
import { ConfigService } from '../shared/services/config/config.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private oauthService: OAuthService,
    private entitlementsService: EntitlementsService,
    private router: Router,
    private configService: ConfigService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (this.configService.authenticationEnabled && !this.oauthService.hasValidAccessToken()) {
      return this.router.createUrlTree(['']); // navigating to the empty route navigates to the AuthComponent, which redirects to Identity
    }

    if (route.data) {
      const entitlements = route.data.entitlements;

      if (entitlements != null && this.configService.entitlementsEnabled) {
        if (!this.entitlementsService.isLoaded()) {
          return this.router.createUrlTree([{outlets: { eepay: 'callback'}}]);
        }

        if (!this.entitlementsService.isEntitled(entitlements)) {
          return this.router.createUrlTree([{outlets: { eepay: ['error', 403]}}]);
        }
      }
    }

    return true;
  }
}
